(function(){
  'use strict';

  if(window.__jfQuickAddInitialized)return;
  window.__jfQuickAddInitialized=true;

  var lastTrigger=null;

  function cartAddUrl(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return root+'cart/add.js';
  }

  function errorMessage(reason){
    return reason.description||reason.message||'Das Produkt konnte nicht hinzugefügt werden.';
  }

  function readJson(container,selector){
    var node=container.querySelector(selector);
    if(!node)return[];
    try{return JSON.parse(node.textContent);}catch(error){return[];}
  }

  function variantsFor(form){
    if(!form.__jfVariants)form.__jfVariants=readJson(form,'[data-jf-variant-data]');
    return form.__jfVariants;
  }

  function gallerySlides(dialog){
    return Array.prototype.slice.call(dialog.querySelectorAll('.jf-quick-add__gallery-slide'));
  }

  function updateGalleryState(dialog,index){
    var slides=gallerySlides(dialog);
    if(!slides.length)return;
    var safeIndex=Math.max(0,Math.min(index,slides.length-1));
    dialog.__jfGalleryIndex=safeIndex;
    dialog.querySelectorAll('[data-jf-gallery-dot]').forEach(function(dot,dotIndex){
      dot.setAttribute('aria-current',dotIndex===safeIndex?'true':'false');
    });
    var previous=dialog.querySelector('[data-jf-gallery-previous]');
    var next=dialog.querySelector('[data-jf-gallery-next]');
    if(previous)previous.disabled=safeIndex===0;
    if(next)next.disabled=safeIndex===slides.length-1;
  }

  function goToGalleryIndex(dialog,index,behavior){
    var track=dialog.querySelector('[data-jf-gallery-track]');
    var slides=gallerySlides(dialog);
    if(!track||!slides.length)return;
    var safeIndex=Math.max(0,Math.min(index,slides.length-1));
    updateGalleryState(dialog,safeIndex);
    track.scrollTo({left:slides[safeIndex].offsetLeft,behavior:behavior||'smooth'});
  }

  function goToMedia(dialog,mediaId){
    if(!mediaId)return;
    var slides=gallerySlides(dialog);
    var index=slides.findIndex(function(slide){
      return String(slide.getAttribute('data-media-id'))===String(mediaId);
    });
    if(index>-1)goToGalleryIndex(dialog,index,'smooth');
  }

  function ensureGallery(dialog){
    var gallery=dialog.querySelector('[data-jf-gallery]');
    var track=dialog.querySelector('[data-jf-gallery-track]');
    var dots=dialog.querySelector('[data-jf-gallery-dots]');
    if(!gallery||!track||gallery.getAttribute('data-gallery-ready')==='true')return;

    var media=readJson(gallery,'[data-jf-media-data]');
    if(media.length){
      track.innerHTML='';
      media.forEach(function(item,index){
        var slide=document.createElement('figure');
        var image=document.createElement('img');
        slide.className='jf-quick-add__gallery-slide';
        slide.setAttribute('data-media-id',item.id||'');
        image.src=item.url;
        image.alt=item.alt||'';
        image.loading=index===0?'eager':'lazy';
        slide.appendChild(image);
        track.appendChild(slide);
      });
    }

    var slides=gallerySlides(dialog);
    if(dots){
      dots.innerHTML='';
      slides.forEach(function(slide,index){
        var dot=document.createElement('button');
        dot.type='button';
        dot.setAttribute('data-jf-gallery-dot','');
        dot.setAttribute('aria-label','Bild '+(index+1)+' von '+slides.length);
        dot.setAttribute('aria-current',index===0?'true':'false');
        dots.appendChild(dot);
      });
    }

    var previous=dialog.querySelector('[data-jf-gallery-previous]');
    var next=dialog.querySelector('[data-jf-gallery-next]');
    if(previous)previous.hidden=slides.length<2;
    if(next)next.hidden=slides.length<2;
    if(dots)dots.hidden=slides.length<2;

    var scrollFrame=null;
    track.addEventListener('scroll',function(){
      if(scrollFrame)cancelAnimationFrame(scrollFrame);
      scrollFrame=requestAnimationFrame(function(){
        var width=track.clientWidth||1;
        updateGalleryState(dialog,Math.round(track.scrollLeft/width));
      });
    },{passive:true});

    gallery.setAttribute('data-gallery-ready','true');
    updateGalleryState(dialog,0);
  }

  function selectedOptions(form){
    return Array.prototype.slice.call(form.querySelectorAll('[data-jf-option-group]'))
      .sort(function(a,b){return Number(a.dataset.optionIndex)-Number(b.dataset.optionIndex);})
      .map(function(group){
        var selected=group.querySelector('[data-jf-option-value][aria-pressed="true"]');
        return selected?selected.getAttribute('data-option-value'):'';
      });
  }

  function selectVariantOptions(form,variant){
    form.querySelectorAll('[data-jf-option-group]').forEach(function(group){
      var index=Number(group.getAttribute('data-option-index'));
      var value=variant.options[index];
      group.querySelectorAll('[data-jf-option-value]').forEach(function(button){
        button.setAttribute('aria-pressed',String(button.getAttribute('data-option-value')===value));
      });
      var label=group.querySelector('[data-jf-selected-option]');
      if(label)label.textContent=value;
    });
  }

  function updateOptionAvailability(form){
    var variants=variantsFor(form);
    form.querySelectorAll('[data-jf-option-group]').forEach(function(group){
      var index=Number(group.getAttribute('data-option-index'));
      group.querySelectorAll('[data-jf-option-value]').forEach(function(button){
        var value=button.getAttribute('data-option-value');
        button.disabled=!variants.some(function(variant){
          return variant.available&&variant.options[index]===value;
        });
      });
    });
  }

  function setVariant(form,variant){
    if(!variant)return;
    selectVariantOptions(form,variant);
    updateOptionAvailability(form);

    var variantInput=form.querySelector('[data-jf-variant-id]');
    if(variantInput)variantInput.value=variant.id;

    var dialog=form.closest('[data-jf-quick-add-dialog]');
    var priceWrapper=dialog.querySelector('[data-jf-quick-add-price]');
    var currentPrice=dialog.querySelector('[data-jf-current-price]');
    var comparePrice=dialog.querySelector('[data-jf-compare-price]');
    if(priceWrapper)priceWrapper.classList.toggle('is-sale',Boolean(variant.compareAt));
    if(currentPrice)currentPrice.textContent=variant.price;
    if(comparePrice){
      comparePrice.textContent=variant.compareAt||'';
      comparePrice.hidden=!variant.compareAt;
    }

    var submitButton=form.querySelector('[data-jf-quick-add-submit]');
    if(submitButton)submitButton.disabled=!variant.available;
    goToMedia(dialog,variant.mediaId);
  }

  function initialiseForm(form){
    var variants=variantsFor(form);
    if(!variants.length)return;
    updateOptionAvailability(form);
    var variantId=form.querySelector('[data-jf-variant-id]');
    var selected=variants.find(function(variant){
      return variantId&&String(variant.id)===String(variantId.value);
    })||variants.find(function(variant){return variant.available;})||variants[0];
    setVariant(form,selected);
  }

  function openDialog(trigger){
    var dialog=document.getElementById(trigger.getAttribute('aria-controls'));
    if(!dialog)return;
    lastTrigger=trigger;
    trigger.setAttribute('aria-expanded','true');
    document.body.appendChild(dialog);
    dialog.hidden=false;
    document.documentElement.classList.add('jf-quick-add-open');
    ensureGallery(dialog);
    var form=dialog.querySelector('[data-jf-quick-add-form]');
    if(form)initialiseForm(form);
    var closeButton=dialog.querySelector('.jf-quick-add__close');
    if(closeButton)closeButton.focus();
  }

  function closeDialog(dialog){
    if(!dialog)return;
    dialog.hidden=true;
    document.documentElement.classList.remove('jf-quick-add-open');
    if(lastTrigger){
      lastTrigger.setAttribute('aria-expanded','false');
      lastTrigger.focus();
      lastTrigger=null;
    }
  }

  function submit(container){
    if(container.classList.contains('is-loading'))return;

    var button=container.querySelector('[data-jf-quick-add-submit]');
    var error=container.querySelector('.jf-quick-add__error');
    var variantInput=container.querySelector('[name="id"]');
    var quantityInput=container.querySelector('[name="quantity"]');
    if(!button||!variantInput||!quantityInput)return;

    var quantity=Math.max(1,parseInt(quantityInput.value,10)||1);
    var payload=new FormData();
    payload.append('id',variantInput.value);
    payload.append('quantity',String(quantity));

    container.classList.add('is-loading');
    container.setAttribute('aria-busy','true');
    button.disabled=true;
    if(error){error.hidden=true;error.textContent='';}

    fetch(cartAddUrl(),{
      method:'POST',
      body:payload,
      credentials:'same-origin',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
    }).then(function(response){
      return response.json().catch(function(){return{};}).then(function(data){
        if(!response.ok)throw data;
        return data;
      });
    }).then(function(){
      closeDialog(container.closest('[data-jf-quick-add-dialog]'));
    }).catch(function(reason){
      if(error){error.textContent=errorMessage(reason||{});error.hidden=false;}
    }).finally(function(){
      container.classList.remove('is-loading');
      container.removeAttribute('aria-busy');
      button.disabled=false;
    });
  }

  document.addEventListener('click',function(event){
    var submitButton=event.target.closest('[data-jf-quick-add-submit]');
    if(submitButton){
      event.preventDefault();
      event.stopPropagation();
      submit(submitButton.closest('[data-jf-quick-add-form]'));
      return;
    }

    var openButton=event.target.closest('[data-jf-quick-add-open]');
    if(openButton){
      event.preventDefault();
      openDialog(openButton);
      return;
    }

    var closeButton=event.target.closest('[data-jf-quick-add-close]');
    if(closeButton){
      event.preventDefault();
      closeDialog(closeButton.closest('[data-jf-quick-add-dialog]'));
      return;
    }

    var optionButton=event.target.closest('[data-jf-option-value]');
    if(optionButton){
      event.preventDefault();
      var form=optionButton.closest('[data-jf-quick-add-form]');
      var group=optionButton.closest('[data-jf-option-group]');
      var optionIndex=Number(group.getAttribute('data-option-index'));
      var optionValue=optionButton.getAttribute('data-option-value');
      group.querySelectorAll('[data-jf-option-value]').forEach(function(button){
        button.setAttribute('aria-pressed',String(button===optionButton));
      });

      var options=selectedOptions(form);
      var variants=variantsFor(form);
      var variant=variants.find(function(item){
        return item.available&&item.options.every(function(value,index){return value===options[index];});
      });
      if(!variant){
        variant=variants.find(function(item){
          return item.available&&item.options[optionIndex]===optionValue;
        });
      }
      if(variant)setVariant(form,variant);
      return;
    }

    var previous=event.target.closest('[data-jf-gallery-previous]');
    var next=event.target.closest('[data-jf-gallery-next]');
    if(previous||next){
      var galleryDialog=(previous||next).closest('[data-jf-quick-add-dialog]');
      var current=galleryDialog.__jfGalleryIndex||0;
      goToGalleryIndex(galleryDialog,current+(next?1:-1),'smooth');
      return;
    }

    var dot=event.target.closest('[data-jf-gallery-dot]');
    if(dot){
      var dotDialog=dot.closest('[data-jf-quick-add-dialog]');
      var dots=Array.prototype.slice.call(dot.parentNode.children);
      goToGalleryIndex(dotDialog,dots.indexOf(dot),'smooth');
      return;
    }

    var minusButton=event.target.closest('[data-jf-quantity-minus]');
    var plusButton=event.target.closest('[data-jf-quantity-plus]');
    if(minusButton||plusButton){
      var quantityControl=(minusButton||plusButton).closest('.jf-quick-add__quantity');
      var input=quantityControl.querySelector('[data-jf-quantity]');
      var currentQuantity=Math.max(1,parseInt(input.value,10)||1);
      input.value=minusButton?Math.max(1,currentQuantity-1):currentQuantity+1;
    }
  });

  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    var dialog=document.querySelector('[data-jf-quick-add-dialog]:not([hidden])');
    if(dialog)closeDialog(dialog);
  });
})();
